import { jsx as _jsx } from "react/jsx-runtime";
import { PRODUCTS } from '@traceio-org/platform-contracts';
import { LOCKUPS } from '../brand/lockups.js';
import { cx } from './cx.js';
/**
 * The official Trace lockup for a product, rendered through <img> as the brand package requires (the
 * SVG files carry their own <style> and must never be inlined into the page).
 */
export function ProductLockup({ productKey, lockup, surface = 'light', className }) {
    const id = lockup ?? (productKey ? PRODUCTS[productKey].lockup : 'trace');
    const source = LOCKUPS[id];
    const artwork = surface === 'dark' ? source.dark : source.light;
    const inverted = surface === 'dark' && source.dark.invert;
    return (_jsx("img", { className: cx('trace-auth-lockup', inverted && 'trace-auth-lockup--invert', className), src: artwork.url, alt: source.alt, width: source.width, height: source.height, decoding: "async", draggable: false, "data-lockup": id, "data-surface": surface }));
}
//# sourceMappingURL=ProductLockup.js.map